// extracted by mini-css-extract-plugin
export default {"messageSeparator":"MessageSeparator_messageSeparator__wBmoN"};